var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7046 34.3829L14.1515 35.1357L14.9567 34.7922L19.5318 32.8411L24.1069 34.7922L24.9121 35.1357L25.359 34.3829L27.9141 30.0796L32.7515 29.0046L33.6133 28.8131L33.5302 27.9343L33.0594 22.9573L36.3553 19.1905L36.9314 18.532L36.3553 17.8735L33.0594 14.1068L33.5302 9.12978L33.6133 8.25092L32.7515 8.05942L27.9141 6.98444L25.359 2.68111L24.9121 1.9284L24.1069 2.27181L19.5318 4.22294L14.9567 2.27181L14.1515 1.9284L13.7046 2.68111L11.1495 6.98444L6.31208 8.05942L5.45032 8.25092L5.53346 9.12978L6.00426 14.1068L2.70836 17.8735L2.13217 18.532L2.70836 19.1905L6.00426 22.9573L5.53346 27.9343L5.45032 28.8131L6.31208 29.0046L11.1495 30.0796L13.7046 34.3829ZM17.299 20.2701L18.006 20.9607L18.7049 20.2618L24.1945 14.7722L24.8504 15.4517L17.9978 22.3043L14.2255 18.532L14.8649 17.8926L17.299 20.2701Z",
    fill: "#008000",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.e0a09a8b4d8dccf4bde624adb6b14059.svg";
export { ForwardRef as ReactComponent };